import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';


const ProtectedRoute = ({ children }) => {
  const location = useLocation(); // Track current route
  const userRole = localStorage.getItem("role"); // Get user role from local storage
   //======================//
  const branches = JSON.parse(localStorage.getItem("branches") || "[]");
  const selectedBranchId = localStorage.getItem("selectedBranchId");

  const selectedBranch = branches.find(
    (b) => b._id === selectedBranchId
  );

  const isAdminMainBranch =
    userRole === "admin" && selectedBranch?.isMainbranch === true;
//============================//

  // If the user is not authenticated, redirect to login
  if (!userRole) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // If the user is authenticated, render the children (protected routes)
  //================//
   if (location.pathname === "/admin/manageBranches" && !isAdminMainBranch) {
   return <Navigate to="/login" replace />;
  }
  //================//
  return children;
};
export default ProtectedRoute;